/**
 * Clear utility
 */

module.exports = clear;


var remove = require('./remove');

/**
 * Removes all children from the given element
 *
 * @param  {DOMElement} element
 * @return {DOMElement} the element (for chaining)
 */
function clear(element) {
  var child;

  while ((child = element.firstChild)) {
    remove(child);
  }

  return element;
}


// WEBPACK FOOTER //
// ./~/tiny-svg/lib/clear.js